import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Routes from "../../../routes";
import {
    BreadCrumbs,
    PageTitleWithToolTip,
    DataGrid,
} from "../../Common";
import { useNavigate, useBreadCrumbs } from "../../../hooks";
import {
    dataGridContainerProps,
    text_commonCellProps,
    select_commonCellProps,
} from "../../Common/DataGrid/utils";
import { getDateRangeFilterOperator } from "../../Common/DataGrid/FilterComponents";
import { fetchFilterValues } from "../../../utils";

const dateRangeFilterOperator = getDateRangeFilterOperator({});

const columns = [
    {
        field: "viewDate",
        headerName: "Date",
        valueGetter: (date) => date,
        renderCell: ({ value }) => value ? new Date(value).toLocaleString() : "",
        filterOperators: dateRangeFilterOperator,
        flex: 1,
        minWidth: 200,
    },
    {
        field: "instanceName",
        headerName: "Instance",
        ...select_commonCellProps,
    },
    {
        field: "userName",
        headerName: "User",
        ...text_commonCellProps,
    },
    {
        field: "userType",
        headerName: "User Type",
        ...select_commonCellProps,
    },
    {
        field: "host",
        headerName: "Host",
        ...select_commonCellProps,
    },
    {
        field: "page",
        headerName: "Page",
        ...text_commonCellProps,
        flex: 1.5,
    },
    {
        field: "ipAddress",
        headerName: "IP Address",
        ...text_commonCellProps,
        initiallyVisible: false,
    },
    {
        field: "browser",
        headerName: "Browser",
        ...text_commonCellProps,
        initiallyVisible: false,
    },
    {
        field: "device",
        headerName: "Device",
        ...select_commonCellProps,
    },
];

const SiteUsage = () => {
    const [filters, setFilters] = useState([]);

    useNavigate({ pageName: "SiteUsage" });
    useBreadCrumbs({
        path: {
            id: "SiteUsage",
            text: "Site Usage",
            link: window.location.pathname,
        },
    });

    useEffect(() => {
        const fetchData = async () => {
            const filterData = await fetchFilterValues(Routes.SiteUsage.Filters());
            setFilters(filterData);
        };

        fetchData();
    }, []);

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: "Geek Command Center", to: "/GeekCommandCenter" },
                    { text: "Site Usage" },
                ]}
            />
            <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                    <PageTitleWithToolTip
                        pageTitle="Site Usage"
                        toolTipText="View platform usage data including page views across all hosts and instances."
                    />
                </Grid>

                <Grid item {...dataGridContainerProps}>
                    <DataGrid
                        url={Routes.SiteUsage.Table()}
                        columns={columns}
                        defaultSort="viewDate_desc"
                        rowCount={50}
                        exportButtonURL={Routes.SiteUsage.TableExport()}
                        exportButtonAlt="Export Site Usage (.csv)"
                        exportFileName="SiteUsage"
                        tableHeader="Recent Page Views"
                        tableHeaderTooltipText="All recorded page views across the platform"
                        filterOptions={filters}
                        noResultText="No page views found"
                        noResultText2="Adjust your filters to see results."
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default SiteUsage;
